<script setup lang="ts">
import { useNavigation } from '@/composables/useNavigation'

/**
 * The side panel, opened and closed by the app bar's menu button: beside the page on a wide screen, over it below
 * 960px. The group titles always show, so nothing moves. The groups and their items follow the caller's roles
 * (useNavigation).
 */
const open = defineModel<boolean>({ required: true })
const { groups } = useNavigation()
</script>

<template>
    <v-navigation-drawer v-model="open" class="app-navigation" data-test="navigation" mobile-breakpoint="md" disable-resize-watcher>
        <v-list density="compact" nav>
            <template v-for="(group, index) in groups" :key="group.key">
                <v-divider v-if="index > 0" class="app-navigation__divider" />
                <v-list-subheader v-if="group.title">{{ group.title }}</v-list-subheader>
                <v-list-item
                    v-for="item in group.items"
                    :key="item.test"
                    :data-test="item.test"
                    :prepend-icon="item.icon"
                    :title="item.title"
                    :to="item.to"
                    :exact="item.exact"
                    color="primary"
                    rounded="lg"
                />
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<style scoped>
.app-navigation__divider {
    margin-block: 4px;
}
</style>
